import { HOST, TENANTS_NAMES } from './host_config';
import xpo from './configs_by_tenant/xpo';
import intraser from './configs_by_tenant/intraser';
import ontruck from './configs_by_tenant/ontruck';
import acme from './configs_by_tenant/acme';

export const getTenantPreLoginConfig = () => {
  const tenantConfig = {
    [TENANTS_NAMES.intraser]: intraser,
    [TENANTS_NAMES.xpo]: xpo,
    [TENANTS_NAMES.ontruck]: ontruck,
    [TENANTS_NAMES.acme]: acme,
  };
  return { ...tenantConfig[HOST] };
};
